<template>
  <div class="latest-news-widget-item">
    <a
      :href="url"
      class="latest-news-widget-item__link"
    >
      <div class="latest-news-widget-item__image-container">
        <img
          :src="imageUrl"
          alt=""
        >
      </div>
      <div class="latest-news-widget-item__text-container">
        <h3 class="latest-news-widget-item__title">{{ title }}</h3>
        <p class="latest-news-widget-item__excerpt">{{ trimmedExcerpt }}</p>
        <div class="latest-news-widget-item__date">
          {{ creationDate.toLocaleDateString(locale) }}
        </div>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  name: 'LatestNewsWidgetItem',
  props: {
    locale: {
      type: String,
      default: 'nl',
    },
    imageUrl: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    excerpt: {
      type: String,
      default: '',
    },
    creationDate: {
      type: Date,
      default: null,
    },
    url: {
      type: String,
      default: '#',
    },
  },
  computed: {
    trimmedExcerpt() {
      return this.excerpt ? this.excerpt.substr(0, 64) + '...' : '';
    },
  },
};
</script>

<style lang="postcss">
.latest-news-widget-item {
  @apply mb-7;

  &:last-child {
    @apply mb-0;
  }

  &__link {
    @apply flex flex-row no-underline text-black hover:text-black;
  }

  &__image-container {
    @apply flex flex-col pr-6 justify-start;

    img {
      width: 5rem;
      min-width: 5rem;
      height: 5rem;
      min-height: 5rem;
      @apply rounded;
    }
  }

  &__title {
    @apply text-lg mb-2 leading-5 font-medium;
  }

  &__excerpt {
    @apply mb-2 text-sm;
  }

  &__date {
    @apply text-xs text-gray-400;
  }
}
</style>
